import React, { useCallback, useEffect, useRef, useState } from "react";
import DynamicTable from "../../../common/DynamicTable";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { getFiltersByReportAsync, generateReportAsync, updateOrigReportDataState } from "./CustomReportViewSlice";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import '../../../common/css/timeLive.css'
import Loader from "../../../common/Loader";
import { CustomReportFilter } from "./CustomReportFilter";
import OffCanvas from "../../../common/OffCanvas";
import { Dropdown } from 'react-bootstrap';
import { generatePDF1 } from "../../../common/generatePDF";
import Select, { StylesConfig } from 'react-select';
import { useTranslation } from "react-i18next";
import { getFilteredList, getPageSizeArray, paginationStyles, getNestedFilteredList, getValueFromResource } from "../../../common/timeLiveFunction";
import * as XLSX from 'xlsx';
import GenericHtmlToPdfDownloader from "../../../common/GenericHtmlToPdfDownloader";
import { MyReports } from "../myReports/MyReports";
import { CSVLink } from "react-csv";
import { toAbsoluteUrl } from "../../../_metronic/helpers";
import { boolean } from "yup";
import MUITableView from "./MUITableView";
import MUISimpleTableView from "./MUISimpleTableView";
import MonthlyReportFilter from "./MonthlyReportFilter";
import fetchAPI from "../../../common/fetchAPI";
import Papa from "papaparse";

const MonthlyJournalReport = () => {
    const dispatch = useAppDispatch();
    // const location = useLocation();
    const { t } = useTranslation();

    const [reportDataArray, setReportDataArray] = useState<any | ''>([]);
    const [reportDataArrayDummy, setReportDataArrayDummy] = useState<any | ''>([]);
    const [reportGroupDataArray, setReportGroupDataArray] = useState<any | ''>([]);
    const [reportColumnsDataArray, setReportColumnsDataArray] = useState<any | ''>([]);
    const [overallTotalsArray, setOverallTotalsArray] = useState<any | ''>([]);
    const [reportSummaryDataArray, setReportSummaryDataArray] = useState<any | ''>([]);
    const [currentItems, setCurrentItems] = useState<any | ''>([]);
    const [pageOptions, setPageOptions] = useState<any | ''>([]);
    const [selectedFilters, setSelectedFilters] = useState<any | ''>([]);
    const [reportId, setReportId] = useState<any | ''>("");
    const [groupReportLabel, setGroupReportLabel] = useState<any | ''>("");
    const csvLinkRef = useRef<any>();

    // Constants for page and row height
    const rowMaxHeight = 20; // Row height in pixels
    const pageHeightMM = 297; // A4 page height in mm
    const mmToPx = 3.7795275591; // Conversion factor from mm to px
    const pageHeightPx = pageHeightMM * mmToPx; // A4 page height in px
    //const rowsPerPage = Math.floor(pageHeightPx / rowHeight); // Rows per page based on row height
    const [rowsPerPage, setRowsPerPage] = useState(0);
    //const [rowMaxHeight, setRowMaxHeight] = useState(19);

    const [pageSize, setPageSize] = useState(rowsPerPage);
    const [currentPage, setCurrentPage] = useState(1);
    const [searchTerm, setSearchTerm] = useState('');
    const [totalPages, setTotalPages] = useState(0);
    const [maxRowIndex, setMaxRowIndex] = useState(-1);

    const [isConsolidated, setIsConsolidated] = useState<boolean>(false);
    const [isPdfExport, setIsPdfExport] = useState<boolean>(false);
    const [iscsvExport, setIscsvExport] = useState<boolean>(false);
    const [isxlsExport, setIsxlsExport] = useState<boolean>(false);
    const [isFirstTimeLoad, setIsFirstTimeLoad] = useState<boolean>(true);
    const [isGenerateReportActive, setIIsGenerateReport] = useState<boolean>(false);
    const [isLoadingLocal, setIsLoadingLocal] = useState<boolean>(false);
    const [isGeneratePdf, setIsGeneratePdf] = useState<boolean>(false);

    const contentRef = useRef<HTMLDivElement>(null);
    const contentRef1 = useRef<HTMLDivElement>(null);
    const tableRef = useRef<HTMLDivElement>(null);
    const [SelectedExportData, setSelectedExportData] = useState('');
    const [SelectedFileName, setSelectedFileName] = useState('');
    const [SelectedColumnHeaders, setSelectedColumnHeaders] = useState<any | ''>([]);
    const [isShowLogoInReport, setIsShowLogoInReport] = useState<boolean>(false);
    const [logoURL, setLogoURL] = useState<string>("");
    const [selectedDates, setSelectedDates] = useState({
        startDate: '',
        endDate: ''
    });
    const navigate = useNavigate();
    const location = useLocation();
    const { ReportName } = location.state;
    const accountId = localStorage.getItem('accountId');


    // Extract accountReportId from state, or use default if not present
    // const AccountReportId = state?.accountReportId || '00000000-0000-0000-0000-000000000000';
    const { AccountReportId } = useParams();

    const { isLoading } = useAppSelector((state) => state.customReportView);

    useEffect(() => {
        if (SelectedFileName) {
            if (csvLinkRef.current) {
                csvLinkRef.current.link.click();
            }
        }

    }, [SelectedFileName])
    const handleSearch = (event: any) => {
        const { value } = event.target;
        setSearchTerm(value);
        setCurrentPage(1);
    };

    const handlePageChange = (selectedOption: any) => {
        const { value, label } = selectedOption;
        if (value >= 1 && value <= totalPages) {
            setCurrentPage(value);
        }
    };

    const handleOnClickEvent = async () => {
        // setIIsGenerateReport(true);
        if (!selectedDates.startDate || !selectedDates.endDate) return;;

        const response: any = await fetchAPI(
            `api/V2/Reports/GenerateMonthlyJournalReportCSV/${accountId}/${selectedDates.startDate}/${selectedDates.endDate}`,
            "POST",
            "",
            true
        );

        const json = await response.json();
        const { data, FileName } = json;
        if (data !== undefined && data !== "") {
            setSelectedColumnHeaders(data.length > 0 ? Object.keys(data[0]) : []);

            const csv = Papa.unparse(data, {
                quotes: false,
                delimiter: ',',
                header: false

            });
            setSelectedExportData(csv);
            setSelectedFileName(FileName);
        }


    }

    const handleDateChange = (startDate: string, endDate: string) => {
        setSelectedDates({ startDate, endDate });
    }

    const generalObject = {
        "name": getValueFromResource('Filters', dispatch, t),
        "width": "700px",
        "componentName": <MonthlyReportFilter AccountReportId={AccountReportId} onDateChange={handleDateChange} onHandleOnClickEvent={handleOnClickEvent} />
    }

    return (
        <>
            <div className="dummyTableContainer"
                ref={tableRef}
                style={{
                    visibility: 'hidden',
                    position: 'absolute',
                    height: '0',
                    width: '0'
                }}
            >
                {reportDataArrayDummy && reportDataArrayDummy.length > 0 &&
                    <table >
                        {reportColumnsDataArray.length > 0 &&
                            <thead>

                                <tr>
                                    {Object.keys(reportColumnsDataArray[0]).map((item: any, index: any) => (
                                        <th key={index}
                                            style={{ maxWidth: `${item.SystemReportDataSourceFieldWidth}px`, width: `${item.SystemReportDataSourceFieldWidth}px`, backgroundColor: '#f0f1f4', borderLeft: '1px solid #ffffff', borderRight: '1px solid #ffffff', fontSize: '12px', fontWeight: '600' }}
                                        >
                                            {item.Caption}
                                        </th>
                                    ))}
                                </tr>
                            </thead>
                        }
                        {reportColumnsDataArray.length > 0 &&
                            <tbody>
                                {maxRowIndex !== -1 && (
                                    <tr>
                                        {reportColumnsDataArray.map((column: any, columnIndex: any) => (
                                            <td key={columnIndex}
                                                style={{
                                                    maxWidth: `${column.SystemReportDataSourceFieldWidth}px`,
                                                    width: `${column.SystemReportDataSourceFieldWidth}px`,
                                                    wordWrap: 'break-word',
                                                    overflowWrap: 'break-word'
                                                }}>
                                                <span className={`d-block `}>
                                                    {Object.values(reportDataArrayDummy[maxRowIndex])[columnIndex] as any}
                                                </span>

                                            </td>
                                        ))}
                                    </tr>
                                )}
                            </tbody>
                        }
                    </table>
                }
            </div>
            <div className="card card-custom admin-card">

                <div className="card-header sticky-top bg-white">
                    <h3 className="card-title fw-bold headerTitle">{getValueFromResource(`${ReportName}`, dispatch, t)}</h3>
                    <div className="card-toolbar align-items-center">
                        <div className="position-relative">
                            <input
                                type="text"
                                value={searchTerm}
                                onChange={handleSearch}
                                placeholder=
                                // {t('Search')}
                                {getValueFromResource('Search', dispatch, t)}
                                className="form-control h-35px w-200px fs-7 fw-normal pr-4"
                                data-kt-user-table-filter="search"
                            />
                            <i className="ki-duotone ki-magnifier fs-5 position-absolute top-50 translate-middle-y end-0" style={{ marginRight: '10px' }}>
                                <span className="path1"></span>
                                <span className="path2"></span>
                            </i>
                        </div>
                        <div className='h-35px w-1px mx-1'></div>
                        {(currentItems.length > 0 || totalPages > 0) ? (
                            <>
                                <div style={{ marginRight: '5px' }}>
                                    {/* {t('Page')} */}
                                    {getValueFromResource('Page', dispatch, t)}
                                </div>
                                <div className="d-flex align-items-center" style={{ marginRight: '5px' }}>
                                    <Select
                                        styles={paginationStyles}
                                        options={pageOptions}
                                        value={pageOptions.find((option: any) => option.value === currentPage)}
                                        onChange={handlePageChange}
                                        className='fs-7 fw-normal'
                                    />
                                </div>
                                <div>
                                    of {totalPages}
                                </div>
                                <div className="d-flex align-items-center">
                                    <ul className="pagination">
                                        <li className="page-item previous" style={currentPage === 1 ? { pointerEvents: 'none', marginRight: '0px', marginLeft: '5px' } : { pointerEvents: 'initial', marginRight: '0px', marginLeft: '5px' }}
                                            onClick={() => handlePageChange({ value: currentPage - 1, label: currentPage - 1 })}  >
                                            <a className="page-link" style={{
                                                borderTopRightRadius: '0px',
                                                borderBottomRightRadius: '0px',
                                                borderTopLeftRadius: '5px',
                                                borderBottomLeftRadius: '5px',
                                            }}>
                                                <i className="previous" ></i>
                                            </a>
                                        </li>
                                        <li className="page-item next" style={(currentPage * pageSize >= totalPages) ? { pointerEvents: 'none' } : { pointerEvents: 'initial' }}
                                            // onClick={() => handlePageChange(currentPage + 1)}
                                            onClick={() => handlePageChange({ value: currentPage + 1, label: currentPage + 1 })}
                                        >
                                            <a className="page-link" style={{
                                                borderTopLeftRadius: '0px',
                                                borderBottomLeftRadius: '0px',
                                                borderTopRightRadius: '5px',
                                                borderBottomRightRadius: '5px',
                                            }}>
                                                <i className="next"></i>
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </>
                        ) : null}
                        <div className='bullet bg-secondary h-35px w-1px mx-3'></div>
                        <a
                            className={`btn btn-icon btn-active-light-dark btn-sm ms-0 ${isGenerateReportActive ? 'active' : ''}`}
                            data-tooltip-id="tooltip-Description"
                            data-tooltip-content=
                            // {t("Generate Report")}
                            {getValueFromResource('Generate Report', dispatch, t)}
                            data-tooltip-place="bottom"
                            onClick={handleOnClickEvent}
                        >
                            <i className={`bi bi-file-text fs-3 iconColor ${isGenerateReportActive ? 'active' : ''}`}></i>
                        </a>
                        <div className='bullet bg-secondary h-35px w-1px mx-3'></div>
                        <a
                            id="kt_OffCanvas"
                            //className={`btn btn-icon btn-active-light-dark btn-sm ms-0 ${isActive ? 'active' : ''}`}
                            className={`btn btn-icon btn-active-light-dark btn-sm ms-0`}
                            data-tooltip-id="tooltip-Description"
                            data-tooltip-content=
                            // {t("Filters")}
                            {getValueFromResource('Filters', dispatch, t)}
                            data-tooltip-place="bottom"
                        //onClick={() => handleToggleAdvancedFilters()}
                        >
                            <i className={`bi bi-filter fs-3 iconColor `}
                            // onClick={() => handleToggleAdvancedFilters()}
                            ></i>
                        </a>

                    </div>

                </div>
                <div className="card-body ">
                    {(isLoading || isLoadingLocal) && <Loader />}
                    <div className="table-responsive" ref={contentRef} style={{ overflowX: 'scroll' }}>
                        {Object.keys(currentItems).length === 0 ? (
                            <div className="overflow-auto pb-5">
                                <div className="notice d-flex bg-light-primary rounded border-primary border border-dashed min-w-lg-600px flex-shrink-0 p-6">
                                    {isFirstTimeLoad ? (
                                        <>
                                            <i className="bi bi-file-text fs-1 text-primary me-2 mt-2">
                                                <span className="path1"></span>
                                                <span className="path2"></span>
                                                <span className="path3"></span>
                                            </i>
                                            <div className="d-flex flex-stack flex-grow-1 flex-wrap flex-md-nowrap">
                                                <div className="mb-3 mb-md-0 fw-semibold">
                                                    <h4 className="text-gray-900 fw-bold">
                                                        {/* {t('Generate Reports')} */}
                                                        {getValueFromResource('Generate Reports', dispatch, t)}
                                                    </h4>
                                                    <div className="fs-7 text-gray-600 pe-7">
                                                        {/* {t("Please Click On 'Generate Report' Button On The Top Right Corner To See Your Report")} */}
                                                        {getValueFromResource('Please Click On "Generate Report" Button On The Top Right Corner To See Your Report', dispatch, t)}
                                                    </div>
                                                </div>
                                            </div>
                                        </>
                                    ) : (
                                        <div className="mb-3 mb-md-0 fw-semibold">
                                            <div className="fs-7 text-gray-600 pe-7 ">
                                                {/* {t('No Data Match Your Criteria. Try Different Filters')} */}
                                                {getValueFromResource('No Data Match Your Criteria. Try Different Filters', dispatch, t)}
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        ) : null}
                    </div>

                </div>
            </div >
            <OffCanvas obj={generalObject} />
            <CSVLink data={SelectedExportData} headers={SelectedColumnHeaders} filename={SelectedFileName} ref={csvLinkRef}  >
            </CSVLink>

        </>
    )
}

export default MonthlyJournalReport